import ProductViewed from './ProductViewed';

export {
  ProductViewed,
};
